import React, { useState, useEffect, useRef } from "react";
import Menu from "../../components/Partials/Menu";
import MenuButton from "../../components/Partials/MenuButton";
import Langs from "../../components/Partials/Langs";
import { Link } from "react-router-dom";
import { translate } from "../../assets/js/functions";

const Header = () => {
  const [hidden, setHidden] = useState(true);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  const toggleVisibility = () => {
    setHidden((prevHidden) => !prevHidden);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setHidden(true);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <header className="mb-7">
      <a href="#main" className="skip-link">Saltar al contenido principal</a>
      <div className="is-flex is-justify-content-space-between px-6 is-align-items-center">
        <MenuButton ref={buttonRef} onClick={toggleVisibility} isOpen={!hidden} />


        <Menu hidden={hidden} ref={menuRef} />
        <p className="has-text-centered has-text-weight-medium mx-auto is-hidden-mobile pl-6">
          <Link to="/" className="link-dn has-text-black">{translate("Maestras y maestros represaliados en Navarra (1936-1976)")}</Link>
        </p>
        <Langs />
      </div>
    </header>
  );
};

export default Header;